import React from 'react';
import { Colors, Metrics } from '../../themes';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => {
  return {
    headerRowContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 20px',
      [theme.breakpoints.down(Metrics.minWidth)]: {
        padding: '0 16px',
      },
    },
    button: {
      margin: 0,
      fontSize: 14,
      color: Colors.white,
      border: `1px solid ${Colors.disabledGrey}`,
      '&:hover': {
        background: Colors.disabledGrey,
      },
      [theme.breakpoints.down(1370)]: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      [theme.breakpoints.down(1300)]: {
        paddingLeft: 8,
        paddingRight: 8,
        fontSize: 12,
      },
      [theme.breakpoints.down(1226)]: {
        paddingLeft: 7,
        paddingRight: 7,
        fontSize: 11,
      },
      [theme.breakpoints.down(1200)]: {
        paddingLeft: 8,
        paddingRight: 8,
        fontSize: 14,
      },
      [theme.breakpoints.down(950)]: {
        fontSize: 12,
        paddingLeft: 6,
        paddingRight: 6,
      },
      [theme.breakpoints.down(850)]: {
        fontSize: 14,
        paddingLeft: 8,
        paddingRight: 8,
      },
      [theme.breakpoints.down(560)]: {
        fontSize: 12,
        paddingLeft: 6,
        paddingRight: 6,
      },
      [theme.breakpoints.down(510)]: {
        fontSize: 10,
      },
      [theme.breakpoints.down(470)]: {
        fontSize: 12,
      },
    },
    errorButton: {
      color: Colors.errorRed,
      borderColor: Colors.errorRed,
      '&:hover': {
        borderColor: Colors.disabledGrey,
      },
    },
  };
});

const AjaxAccessLevelTableHeader = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.headerRowContainer}>
      <Typography variant="h2">AJAX</Typography>
      <Button
        type="button"
        variant="outlined"
        className={classes.button}
        onClick={props.onAddHubsButtonClick}
        endIcon={<AddIcon width={20} />}
        disabled={props.add2ButtonDisabled}
      >
        {t('accessLevels.addAccessLevelHubButton')}
      </Button>
    </div>
  );
};

export default AjaxAccessLevelTableHeader;
